import { Link } from "react-router-dom";

interface Props {
  property1: "variant-2" | "variant-3" | "default";
  className: any;
  text: string;
  url?:string;
}

export const AppbarTexts = ({
  property1,
  className,
  text = "/",
  url="",
}: Props): JSX.Element => {
  return (
    <div
      className={`inline-flex items-center gap-[12px] px-[16px] py-[10px] rounded-[8px] hover:text-primary relative cursor-pointer ${className}`}
    >
      <Link to={url}>
      <div
        className={`[font-family:'Roboto',Helvetica] w-fit mt-[-1.00px] tracking-[0] text-[16px] hover:text-primary relative font-medium whitespace-nowrap leading-[normal]`}
      >
        {text}
      </div>
      </Link>
    </div>
  );
};
